<script>
export default {
  props: {
    heading: { type: String, required: true },
    alert: { type: String, default: '' },
  },
}
</script>

<template>
  <section class="flex justify-center items-center h-screen">
    <div class="flex flex-col w-full max-w-sm max-h-screen overflow-hidden py-8">
      <div
        v-if="alert"
        class="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded relative mb-6"
        role="alert"
      >
        <span class="block sm:inline">{{ alert }}</span>
      </div>

      <div class="bg-white rounded-sm shadow overflow-y-auto max-h-full">
        <div class="px-6 py-4">
          <div class="relative mb-6">
            <BaseLink
              class="block h-full absolute left-0"
              name="property-landing"
            >
              <span class="px-3 text-lg">
                <i class="fas fa-chevron-left"></i>
              </span>
            </BaseLink>
            <h3 class="font-medium text-xl text-gold-500 text-center uppercase">
              {{ heading }}
            </h3>
          </div>

          <slot></slot>
        </div>
      </div>
    </div>
  </section>
</template>
